var _a, _b, _c;
import { __decorate, __metadata } from "tslib";
import { Module, VuexModule, Action } from 'vuex-module-decorators';
import { Actions } from '@/store/enums/StoreEnums';
let BodyModule = class BodyModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.classes = {};
    }
    [_a = Actions.ADD_BODY_CLASSNAME](className) {
        document.body.classList.add(className);
    }
    [_b = Actions.REMOVE_BODY_CLASSNAME](className) {
        document.body.classList.remove(className);
    }
    [_c = Actions.ADD_BODY_ATTRIBUTE](payload) {
        const { qulifiedName, value } = payload;
        document.body.setAttribute(qulifiedName, value);
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BodyModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BodyModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BodyModule.prototype, _c, null);
BodyModule = __decorate([
    Module
], BodyModule);
export default BodyModule;
